import { toast } from 'react-toastify';
import { getErrorMessage } from 'utils/utilities';
import * as yup from 'yup';

export const hideEmailPhoneInfo = (value) => {
    if (typeof value !== 'string') return;
    let firstChar = value.charAt(0);
    let replacedString = firstChar + value.substring(1, 5).replace(/./g, '*') + value.slice(5);
    return replacedString;
};

export const getReauthenticateAdditionalMethodData = (additionalVerification) => {
    if (!additionalVerification) return {};

    const verifyMethod = additionalVerification?.email ? 'Email' : 'Phone';

    const verifyMethodData =
        verifyMethod === 'Email' ? additionalVerification.email : additionalVerification?.phone;

    return { ...verifyMethodData, method: verifyMethod };
};

export const handleError = (error) => toast.error(getErrorMessage(error));

export const validationSchema = yup.object({
    code: yup.string('Enter your code').required('Verification code is required').length(6),
});
